export default __webpack_public_path__ + "557f69b954bc880946310bef04081981.png";